import { render } from "./PermissionSettingsCheckbox.vue?vue&type=template&id=0fd793be&scoped=true"
import script from "./PermissionSettingsCheckbox.vue?vue&type=script&lang=js"
export * from "./PermissionSettingsCheckbox.vue?vue&type=script&lang=js"

import "./PermissionSettingsCheckbox.vue?vue&type=style&index=0&id=0fd793be&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd793be"]])

export default __exports__